import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Calculator, Eye } from "lucide-react";

export function QuickCalculate({ palletQuantity, setPalletQuantity, selectedPalletType, loading, handleCalculate }) {
  return (
    <Card
      className="bg-white border border-zinc-200 rounded-none shadow-none md:col-span-2 lg:col-span-3"
      data-testid="calculator-card"
    >
      <CardHeader className="p-6 pb-4">
        <CardTitle
          className="text-xl font-bold text-zinc-900 tracking-tight flex items-center gap-2"
          style={{ fontFamily: "Chivo, sans-serif" }}
        >
          <Calculator className="w-6 h-6 text-orange-600" />
          Quick Calculate
        </CardTitle>
      </CardHeader>
      <CardContent className="p-6 pt-0">
        <div className="flex gap-4 items-end">
          <div className="flex-1">
            <Label
              htmlFor="quantity"
              className="text-xs uppercase tracking-[0.2em] font-medium text-zinc-500 mb-2 block"
            >
              Number of Pallets
            </Label>
            <Input
              id="quantity"
              type="number"
              min="1"
              value={palletQuantity}
              onChange={(e) => setPalletQuantity(e.target.value.slice(0, 6))}
              placeholder="Enter quantity"
              className="bg-white border border-zinc-300 rounded-none shadow-none focus-visible:ring-2 focus-visible:ring-orange-600 focus-visible:ring-offset-0 text-lg h-12"
              data-testid="pallet-quantity-input"
            />
          </div>
          <div className="flex flex-col gap-2">
            <Button
              onClick={() => window.dispatchEvent(new CustomEvent('view-pallet-details', { detail: selectedPalletType }))}
              disabled={!selectedPalletType}
              variant="outline"
              className="rounded-none font-semibold tracking-wide h-9 px-4 border-zinc-300 text-zinc-700 hover:bg-zinc-50 disabled:opacity-50"
              data-testid="view-details-calc-btn"
            >
              <Eye className="w-4 h-4 mr-2" />
              View Details
            </Button>
            <Button
              onClick={handleCalculate}
              disabled={!selectedPalletType || loading}
              className="bg-orange-600 hover:bg-orange-700 text-white rounded-none font-semibold tracking-wide h-12 px-8 disabled:opacity-50"
              data-testid="calculate-btn"
            >
              <Calculator className="w-5 h-5 mr-2" />
              Calculate
            </Button>
          </div>
        </div>
        {!selectedPalletType && (
          <p className="text-sm text-zinc-500 mt-3">Select a pallet type from the list first</p>
        )}
      </CardContent>
    </Card>
  );
}
